export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const BSC_RPC_ENDPOINT = process.env.REACT_APP_BSC_RPC_ENDPOINT || 'https://bsc-dataseed1.binance.org/';
export const BSC_CHAIN_ID = 56; // BSC Mainnet Chain ID
// 指定memecoin

